import { render } from "./filterTabs.vue?vue&type=template&id=38d0634d&scoped=true"
import script from "./filterTabs.vue?vue&type=script&lang=js"
export * from "./filterTabs.vue?vue&type=script&lang=js"

import "./filterTabs.vue?vue&type=style&index=0&id=38d0634d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d0634d"]])

export default __exports__